export enum AllocationRulesTabsEnum {
  SALES = 'sales',
  PURCHASES = 'purchases',
  PRODUCT_TYPES = 'product-types',
  OTHER = 'other',
}
